import {gsap, Power4} from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

import {breakpointUp} from '../utils/breakpoints'

gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(ScrollTrigger)

let current_page = document.documentElement.getAttribute('data-page');
let current_url = document.documentElement.getAttribute('data-url');

let videoV = $('#hero-video')
let video = null
if (videoV.length) {
  video = videoV[0]
}

function initHero(tl) {
  tl.play()
}

if (isIndexPage()) {
  let shapes = '.block-hero .animation-line'
  let tl = gsap.timeline({ paused: true, repeat: 0, yoyo: false })
  tl.fromTo(shapes, { drawSVG: "100% 100%" }, { duration: 1.5, drawSVG: "0% 100%", delay: 0.5, stagger: 0.1 })

  if (breakpointUp('xl')) {
    gsap.set('.block-hero video', { scale: 1.15 })
  }

  $(window).on('load', function () {
    initHero(tl)
    if (breakpointUp('xl')) {
      gsap.to('.block-hero video', { scale: 1, duration: 1.5, onComplete: videoPlay })
    }
  })
}

function videoPlay() {
  if (!video) {
    return false
  }
  $('.block-hero .c-video-pause').hide()
  $('.block-hero .c-video-play').show()
  video.play()
}

function videoPause() {
  if (!video) {
    return false
  }
  $('.block-hero .c-video-play').hide()
  $('.block-hero .c-video-pause').show()
  video.pause()
}

const $body = $('body')

$('body').on('click', '.block-hero .c-video-play', function () {
  videoPause()
})

$('body').on('click', '.block-hero .c-video-pause', function () {
  videoPlay()
})

if ($('#video-player').length) {
  ScrollTrigger.create({
    trigger: '#video-player',
    start: 'bottom top',
    end: 'bottom top+=10%',
    scrub: true,
    //markers: true,
    onLeave: () => {
      videoPause()
    },
    onEnterBack: () => {
      videoPlay()
    }
  })
}

const heroVideoC = $('.block-hero .block-column-video')
const videoP = $('.block-hero video')

window.sizeHeroVideo = () => {
  videoV.removeClass('video-h')
  if (heroVideoC.length && videoP.length) {
    if (videoP.height() < heroVideoC.height()) {
      videoV.addClass('video-h')
    }
  }
}
// $(document).ready(() => {
//   setTimeout(() => {
//     sizeHeroVideo();
//   }, 1000)
//
// })
let lastWidth = $(window).width();
$(window).on('resize', function () {
  const currentWidth = $(window).width();
  if (currentWidth !== lastWidth) {
    lastWidth = currentWidth;
    setTimeout(() => {
      sizeHeroVideo();
    }, 300)
  }
})

$body.on('click', '.pause-hero-video', function (e) {
  e.preventDefault()
  videoPause()
})

$body.on('click', '.play-hero-video', function (e) {
  e.preventDefault()
  videoPlay()
})

function isIndexPage() {
  return current_page === 'index';
}

export { videoPause, videoPlay }
